import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { InputAdornment } from '@material-ui/core';

import {
  RiGlobalLine,
  RiFacebookCircleFill,
  RiLinkedinBoxFill,
  RiInstagramFill,
  RiTwitterXFill,
} from 'react-icons/ri';

import { TextInput } from '@Components/common';
import styles from './SocialMediaFields.module.scss';

interface SocialMediaFieldsProps {
  isSaving?: boolean;
}

export const SocialMediaFields: React.FC<SocialMediaFieldsProps> = ({ isSaving }) => {
  const { t } = useTranslation('createAccount');
  const { register, errors: fieldErrors } = useFormContext();

  return (
    <>
      <TextInput
        label={t('create_profile_common.website')}
        placeholder="https://www.example.com"
        inputRef={register}
        name="website_url"
        error={!!fieldErrors.website_url}
        helperText={fieldErrors.website_url?.message}
        disabled={isSaving}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <RiGlobalLine size={24} />
            </InputAdornment>
          ),
        }}
      />

      <div className={styles.halfWidth}>
        <TextInput
          label={t('create_profile_common.facebook')}
          placeholder="www.facebook.com/MyUsername"
          inputRef={register}
          name="facebook_url"
          error={!!fieldErrors.facebook_url}
          helperText={fieldErrors.facebook_url?.message}
          disabled={isSaving}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RiFacebookCircleFill size={24} />
              </InputAdornment>
            ),
          }}
        />
        <TextInput
          label={t('create_profile_common.linkedin')}
          placeholder="www.linkedin.com/company/MyUsername"
          inputRef={register}
          name="linkedin_url"
          error={!!fieldErrors.linkedin_url}
          helperText={fieldErrors.linkedin_url?.message}
          disabled={isSaving}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RiLinkedinBoxFill size={24} />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <div className={styles.halfWidth}>
        <TextInput
          label={t('create_profile_common.instagram')}
          placeholder="www.instagram.com/MyUsername"
          inputRef={register}
          name="instagram_url"
          error={!!fieldErrors.instagram_url}
          helperText={fieldErrors.instagram_url?.message}
          disabled={isSaving}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RiInstagramFill size={24} />
              </InputAdornment>
            ),
          }}
        />
        <TextInput
          label={t('create_profile_common.twitter')}
          placeholder="www.x.com/MyUsername"
          inputRef={register}
          name="twitter_url"
          error={!!fieldErrors.twitter_url}
          helperText={fieldErrors.twitter_url?.message}
          disabled={isSaving}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RiTwitterXFill size={24} />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
};
